import { useState } from "react";
import { IconSearch, IconX } from "@tabler/icons-react";

const Searching = (props) => {
  const [search, setSearch] = useState("");

  const {
    data,
    setData,
    type,
    serverSearching,
    setSearchValue,
    placeholder = "Search by name, code or keyword...",
  } = props;

  // UPDATED FILTER LOGIC for Nested Search
  const includesValue = (value, searchValueLower) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") {
      return value.toLowerCase().includes(searchValueLower);
    }
    if (typeof value === "number") {
      return value.toString().includes(searchValueLower);
    }
    return false;
  };

  // Match "first last" so queries with spaces (e.g. "david l") work
  const includesFullName = (firstName, lastName, searchValueLower) => {
    const fullName = `${firstName || ""} ${lastName || ""}`.trim();
    return includesValue(fullName, searchValueLower);
  };

  const filterOrders = (dataArray, searchValueLower) => {
    return (dataArray || []).filter((orderItem) => {
      // Root fields (orderId, etc.)
      const rootMatch = Object.keys(orderItem || {}).some((key) => {
        if (["_id", "updatedAt", "createdAt", "reportDate"].includes(key)) {
          return false;
        }
        return includesValue(orderItem[key], searchValueLower);
      });

      // Full name on root (User / Seller tables)
      const rootFullNameMatch = includesFullName(
        orderItem.firstName,
        orderItem.lastName,
        searchValueLower
      );

      // User Info (firstName, lastName, uniqueId, email)
      const userMatch =
        orderItem.userId &&
        (includesValue(orderItem.userId.firstName, searchValueLower) ||
          includesValue(orderItem.userId.lastName, searchValueLower) ||
          includesFullName(
            orderItem.userId.firstName,
            orderItem.userId.lastName,
            searchValueLower
          ) ||
          includesValue(orderItem.userId.uniqueId, searchValueLower) ||
          includesValue(orderItem.userId.email, searchValueLower));

      // Seller Info (reels / redeem / nested seller objects)
      const sellerMatch =
        orderItem.sellerId &&
        (includesValue(orderItem.sellerId.firstName, searchValueLower) ||
          includesValue(orderItem.sellerId.lastName, searchValueLower) ||
          includesFullName(
            orderItem.sellerId.firstName,
            orderItem.sellerId.lastName,
            searchValueLower
          ) ||
          includesValue(orderItem.sellerId.email, searchValueLower) ||
          includesValue(orderItem.sellerId.mobileNumber, searchValueLower) ||
          includesValue(orderItem.sellerId.businessName, searchValueLower) ||
          includesValue(orderItem.sellerId.businessTag, searchValueLower) ||
          includesValue(orderItem.sellerId.uniqueId, searchValueLower));

      // Category / SubCategory (products)
      const categoryMatch =
        includesValue(orderItem.category?.name, searchValueLower) ||
        includesValue(orderItem.subCategory?.name, searchValueLower);

      // Address country (seller request)
      const addressMatch = includesValue(
        orderItem.address?.country,
        searchValueLower
      );

      // Items array (multiple items per order)
      const itemsMatch =
        orderItem.items &&
        orderItem.items.some(
          (item) =>
            includesValue(item.productId?.productName, searchValueLower) ||
            includesValue(item.productId?.productCode, searchValueLower) ||
            includesValue(item.productQuantity, searchValueLower) ||
            includesValue(item.purchasedTimeProductPrice, searchValueLower)
        );

      return (
        rootMatch ||
        rootFullNameMatch ||
        userMatch ||
        sellerMatch ||
        categoryMatch ||
        addressMatch ||
        itemsMatch
      );
    });
  };

  const applySearch = (inputValue) => {
    const searchValueLower = (inputValue || "").toLowerCase();

    if (setSearchValue) {
      setSearchValue(inputValue);
    }

    if (type === "client") {
      if (searchValueLower) {
        const filteredData = filterOrders(data, searchValueLower);
        setData(filteredData);
      } else {
        setData(data);
      }
    } else if (serverSearching) {
      serverSearching(searchValueLower);
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setSearch(inputValue);
    applySearch(inputValue);
  };

  const handleClearSearch = () => {
    setSearch("");
    applySearch("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      applySearch(search);
    }
  };

  return (
    <div className="col-11 col-md-6 col-lg-8 d-flex justify-content-end">
      <div
        className="d-flex align-items-center"
        style={{
          width: "100%",
          maxWidth: "420px",
          backgroundColor: "#fff",
          border: "1px solid #e8e4e6",
          borderRadius: "50px",
          padding: "10px 18px",
          boxShadow: "0 2px 8px rgba(185, 49, 96, 0.06)",
        }}
      >
        <IconSearch
          size={18}
          stroke={2}
          style={{ color: "#b93160", flexShrink: 0 }}
        />
        <input
          type="text"
          autoComplete="off"
          placeholder={placeholder}
          aria-describedby="button-addon4"
          value={search}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          style={{
            border: "none",
            outline: "none",
            background: "transparent",
            width: "100%",
            marginLeft: "10px",
            marginRight: search ? "8px" : "0px",
            fontSize: "14px",
            color: "#2f2b3d",
          }}
        />
        {search ? (
          <button
            type="button"
            onClick={handleClearSearch}
            aria-label="Clear search"
            style={{
              border: "none",
              background: "transparent",
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              flexShrink: 0,
              color: "#9a9398",
            }}
          >
            <IconX size={16} stroke={2} />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default Searching;
